import req from '../req'
// 客户-潜客

// 获取潜客列表
export function getPotentialCustomerList (params) {
  return req.get('/members/potential-member', params)
}

// 删除潜客
export function deletePotentialCustomerList (potentialMemberId, params) {
  return req.post('/members/potential-member/delete/' + potentialMemberId, params)
}
